module.exports = __webpack_public_path__ + "img/43.3a8a7618.svg";